import React from "react";
import { Link as ReactRouterLink, LinkProps } from "react-router-dom";

export const Link: React.FC<LinkProps> = props => {
  return <ReactRouterLink {...props} />;
};
